export default __webpack_public_path__ + "static/button-alignment-modal-dark-1a71a2ec9240b256dc48ea9fb6894132f4a4a19b7a28191fc5df344047d99eae.png";